function getUserProfile(token) {
    return fetch(`${process.env.REACT_APP_API_ENDPOINT}/auth/profile?version=2`, {
        headers: {
            Accept: 'application/json',
            Authorization: token,
        }
    }).then(response => {
        const statusCode = response.status;
        const data = response.json();

        return Promise.all([statusCode, data]).then(res => {
            return {
                statusCode: res[0],
                data: res[1],
            };
        });
    })
        .catch(error => {
            console.error(error)
        });
}

function getLivestreamDetails(ID, token) {
    const param = {
        query: `
            query GetLiveStreamByID($ID: String!) {
            GetLiveStreamByID(ID: $ID) {
                ID
                Signature
                MeetingID
                MeetingPassword
            }
            }
        `,
        variables: {
            ID,
        }
    };

    return fetch(`${process.env.REACT_APP_API_ENDPOINT}/live-stream/graphql`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: token,
        },
        body: JSON.stringify(param),
    })
        .then(res => res.json())
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.error(error)
        })
}

function pingZoomSession(livestreamId, token) {
    return fetch(`${process.env.REACT_APP_API_ENDPOINT}/live-stream/ping?live-stream-id=${livestreamId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: token,
        }
    }).then(response => {
        const statusCode = response.status;
        const data = response;

        return Promise.all([statusCode, data]).then(res => {
            return {
                statusCode: res[0],
                data: res[1],
            };
        });
    }).catch(error => {
        console.error("Error when pingZoom", error);
    });
}

function invalidateCacheZoomSession(token) {
    const param = {
        query: `
            mutation {
                InvalidateCache
            }
        `
    };

    return fetch(`${process.env.REACT_APP_API_ENDPOINT}/live-stream/graphql`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: token,
        },
        body: JSON.stringify(param),
    })
        .then(res => res.json())
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.error(error)
        })
}

export { getUserProfile, getLivestreamDetails, pingZoomSession, invalidateCacheZoomSession};